import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import { backgroundListGetError } from "../../../store/screen/slice";
const CustomDraggingStyle = ({ children, dragProps, snapshot }: any) => {
  const { style, ...propsData } = dragProps.draggableProps;
  const { position, ...otherStyle } = style;

  return (
  <div
    ref={dragProps.innerRef}
    {...propsData}
    {...dragProps.dragHandleProps}
    className={`student-item ${snapshot.isDragging? "item-isDragging": ""}`}
    data-interaction-ignore-drag="true"
    data-interaction-target-type="false"
    style={{
      position: 'relative',
      ...otherStyle,
    }}
  >
    {children}
  </div>
); // Use div instead of DraggingStyle
};

export default CustomDraggingStyle;
